"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const translate_1 = require("components/translate");
const constants_1 = require("./constants");
class DefaultClassUtil {
    constructor() {
        this.appendMarkToName = (name) => {
            if (this.isDefault(name)) {
                const defaultClassMark = translate_1.Polyglot.t(constants_1.DEFAULT_CLASS.INFO, {
                    checkOnlineEvent: true
                });
                const defaultName = this.getName(name);
                return `${defaultName} (${defaultClassMark})`;
            }
            return name;
        };
        this.getName = (name) => {
            if (this.isDefault(name)) {
                return this.getTranslatedLabel();
            }
            return name;
        };
        this.getTranslatedLabel = () => {
            return translate_1.Polyglot.t(constants_1.DEFAULT_CLASS.NAME);
        };
        this.isDefault = (name) => {
            return name === constants_1.DEFAULT_CLASS.ENTITY;
        };
    }
}
exports.default = new DefaultClassUtil();
